import { Component, NgZone, ElementRef, ViewChild, OnInit, AfterViewInit } from '@angular/core';
import { AppConfig } from 'src/config/app-config.service';
import { IAppConfig } from 'src/config/app-config.model';
import { Language } from 'src/core/utility/enums/enums';
import { TranslateService } from '@ngx-translate/core';
import { BaseTranslation } from 'src/core/translation/model/translation.base';
import { HomeService } from '../../services/home.service';
import LazyLoad from "vanilla-lazyload";


@Component({
  selector: 'adahi-introduction',
  templateUrl: './introduction.component.html'
})
export class IntroductionComponent extends BaseTranslation implements OnInit, AfterViewInit {

  appSettings: IAppConfig;
  contributePageUrl: string;
  introduction: string;
  @ViewChild('itemBg') itemBg: ElementRef;

  constructor(translate: TranslateService, ngZone: NgZone,
    private homeService: HomeService) {
    super(translate, ngZone);
    this.translate.get('home.introduction.introduction').subscribe((res) => {
      this.introduction = res["home.introduction.introduction"];
    });
    this.appSettings = AppConfig.settings;

  }

  ngOnInit() {
    this.homeService.isRepresentative().subscribe(result => {
      if (result) {
        this.contributePageUrl = "/" + Language[_spPageContextInfo.currentLanguage] + this.appSettings.sellRitualPage;
      } else {
        this.contributePageUrl = "/" + Language[_spPageContextInfo.currentLanguage] + this.appSettings.contributePageUrl;
      }
    }, err => {
      this.contributePageUrl = "/" + Language[_spPageContextInfo.currentLanguage] + this.appSettings.contributePageUrl;
    });

  }

  truncate(string, charNum) {
    if (string.length > charNum)
      return string.substring(0, charNum) + '...';
    else
      return string;
  }

  // createRenderElement(parentElement, name, attrs) {
  //   var el = document.createElement(name);

  //   // insertion in DOM before applying attributes doesn't work in Firefox
  //   //parentElement.appendChild(el);

  //   for (var i = 0; i < attrs.length; i += 2) {
  //     el.setAttribute(attrs[i], attrs[i + 1]);
  //   }

  //   // will work in Firefox
  //   parentElement.appendChild(el);

  //   return el;
  // }

  // renderPictureElement() {
  //   let picture = this.createRenderElement((<HTMLElement>this.itemBg.nativeElement), 'picture', []);

  //   this.createRenderElement(picture, 'source', ['media', '(max-width: 1199.98px)', 'srcset', '/Style%20Library/Adahi/images/Kaaba-2-mobile.jpg']);

  //   this.createRenderElement(picture, 'source', ['media', '(min-width: 1200px)', 'srcset', '/Style%20Library/Adahi/images/Kaaba-2.jpg']);

  //   this.createRenderElement(picture, 'img', ['src', '/Style%20Library/Adahi/images/Kaaba-2.jpg', 'class', 'home-slider__item-img']);
  // }

  ngAfterViewInit() {
    // this.renderPictureElement();
    var lazyLazy = new LazyLoad({
      elements_selector: "img.lazy",
      callback_loaded: function(el) {
        (<HTMLElement>el).closest('.home-slider__item-bg').classList.remove('lazy');
      }
    });
  }

}
